/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_LegendsInputs */

const en_directory_footer_link_legends = /** @type {(inputs: Directory_Footer_Link_LegendsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Legends`)
};

const zh_directory_footer_link_legends = /** @type {(inputs: Directory_Footer_Link_LegendsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传奇发布`)
};

/**
* | output |
* | --- |
* | "Launch Legends" |
*
* @param {Directory_Footer_Link_LegendsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_legends = /** @type {((inputs?: Directory_Footer_Link_LegendsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_LegendsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_legends(inputs)
	return zh_directory_footer_link_legends(inputs)
});
export { directory_footer_link_legends as "directory.footer.link_legends" }